/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { useCreateEventContext } from "../../../../context/CreateEventContext";
import { useAuth } from "../../../../context/AuthContext";
import ModalLoadingState from "../../../PopUpModal/ModalLoadingState";
import RequiredDocumentsStep from "../RequiredDocumentsStep";
import document_icon from "../../../../assets/images/upload_document.svg";

const EventDocuments = () => {
  const { t } = useTranslation();
  const { id: eventId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const { getEventData, eventData } = useCreateEventContext();
  const { user } = useAuth();

  useEffect(() => {
    if (eventId) {
      const fetchEvent = async () => {
        setIsLoading(true);
        try {
          await getEventData(eventId);
        } catch (error) {
          console.log("error fetching event", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchEvent();
    }
  }, [eventId]);

  return (
    <>
      {isLoading ? (
        <ModalLoadingState />
      ) : (
        <div className="w-full p-6 space-y-8">
          {/* Required Documents — signing & acknowledgment */}
          <div>
            <h2 className="text-xl font-medium text-grey-900 mb-1">Required Documents</h2>
            <p className="text-sm text-grey-500 mb-4">
              Review and sign documents required by the event organizer.
            </p>
            <RequiredDocumentsStep
              eventId={eventId}
              vendorId={user?.uid}
              vendorName={user?.displayName || user?.businessName || 'Vendor'}
            />
          </div>

          {/* General Event Documents (legacy uploads) */}
          {eventData?.eventDocuments?.length > 0 && (
            <div>
              <h2 className="text-xl font-medium text-grey-900 mb-4">Event Documents</h2>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {eventData.eventDocuments.map((document, index) => (
                  <a
                    href={document.file}
                    target="_blank"
                    rel="noreferrer"
                    key={index}
                    className="border border-grey-300 rounded-2xl p-8 flex flex-col items-center justify-center"
                  >
                    <img src={document_icon} alt="" className="h-[40px] w-[40px]" />
                    <p className="pt-2 text-sm font-medium text-success-700 whitespace-nowrap">
                      {document?.fileName?.length > 15
                        ? `${document?.fileName.slice(0, 15)}...`
                        : document?.fileName}
                    </p>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default EventDocuments;
